<template>
  <a-layout>

    <a-layout-header class="header" style="background: #eee; height: 40px">
      <a-row>
        <a-col flex="auto">
          <a-breadcrumb style="margin-top: 10px; margin-left: -20px">
            <template v-for="breadcrumb in breadcrumbs">
              <a-breadcrumb-item>{{ breadcrumb }}</a-breadcrumb-item>
            </template>
          </a-breadcrumb>
        </a-col>
        <a-col flex="50px" style="line-height: 40px;">
          <a-button type="primary" @click="showCommitModal" :loading="save_in_progress" :disabled="!save_button_enabled">
            <template #icon> <save-outlined/> </template>
            Save
          </a-button>
        </a-col>
      </a-row>
    </a-layout-header>
  </a-layout>
  <a-layout>
    <a-layout-sider width="350" :style="{ overflow: 'auto', background: '#fff' }">
      <a-spin size="large" :spinning="is_tree_loading" :tip="'Loading: ' + id">
        <a-tree style="padding: 5px"
                :show-line="true"
                v-model:expandedKeys="expandedKeys"
                v-model:selectedKeys="selectedKeys"
                :tree-data="treeData"
                @select="selectTreeItem"
        >
          <template #title="{ dataRef }">
            <a-dropdown :trigger="['contextmenu']">
              <div>
                <span class="feature_prefix" v-if="dataRef.feature"> ({{ dataRef.feature }})</span>
                <span style="font-weight: normal">&nbsp;{{ dataRef.title }}</span><br/>
                <span class="label_suffix">[{{ dataRef.etype }}]</span>
              </div>
              <!-- multi-row does not work??            <div><span>Test</span></div>-->

              <template #overlay>
                <a-menu @click="({ item: menuItem, key: menuKey }) => onContextMenuClick(dataRef, menuKey, menuItem)">
                  <template v-for="c_ref in dataRef.containment_refs">
                    <a-menu-item :key="c_ref.name" v-if="c_ref.set && c_ref.many">Add {{ ucFirst(c_ref.name) }}</a-menu-item>
                    <a-menu-item :key="c_ref.name" v-if="!c_ref.set">Add {{ ucFirst(c_ref.name) }}</a-menu-item>
                  </template>
                  <a-menu-item key="delete">Delete</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </template>
        </a-tree>
      </a-spin>
    </a-layout-sider>
    <a-layout style="padding: 0 5px 5px 5px">

      <a-layout-content
          :style="{ background: '#fff', padding: '4px', margin: 0, minHeight: '280px' }"
      >
        <template v-if="!is_prop_loading">
          <h2>
              <span
                  v-if="obj_properties.object"
                  :title="obj_properties.object.doc"
              >
                {{ obj_properties.object.name ? obj_properties.object.name : obj_properties.object.type }}
              </span>
               <a-tooltip :title="obj_properties.object.doc">
                        <span>&nbsp;<info-circle-outlined style="color: rgba(0, 0,255, 0.45);" /></span>
               </a-tooltip>
          </h2>
        </template>

        <div v-if="!is_prop_loading && obj_properties" id="object-properties">
          <a-row v-if="obj_properties.object.type !== 'Image'">
            <a-col :span="24">
              <div style="margin-bottom: 10px;">
                <a-row v-for="attr in obj_properties.attributes" :key="attr.name" :gutter="[0,4]" type="flex"
                       align="top" style="margin-bottom: 3px;">
                  <!-- attributes -->
                  <a-col v-if="isAttribute(attr)" :span="8">
                    <span :title="attr.doc">{{ camelCase(attr.name) }}</span>
                  </a-col>
                  <a-col v-if="isAttribute(attr)" :span="15">
                    <FancyNumberEdit
                        v-if="attr.type === 'EInt' || attr.type === 'EDouble' || attr.type === 'ELong' || attr.type === 'EIntegerObject'"
                        :value="asNumber(attr.value)"
                        v-model:unit="attr.unit"
                        @change="(val) => eddChanged(attr, val)"
                        @update:value="(val) => { updateAttribute(attr.name, val, attr, obj_properties.object);}"
                    />
                    <a-input
                        v-else-if="attr.type === 'EString' && attr.name !== 'description' && !attr.many"
                        v-model:value="attr.value"
                        type="text"
                        @change="(e) => eddChanged(attr, e)"
                        @blur="updateAttribute(attr.name, attr.value, attr, obj_properties.object)"
                    />
                    <template v-else-if="attr.type === 'EString' && attr.name === 'tags'">
                      <TagEditor
                        v-model:tags="attr.value"
                        @update:tags="(val) => { eddChanged(attr, val); updateAttribute(attr.name, val, attr, obj_properties.object);}"
                      />
                    </template>
                    <template v-else-if="attr.type === 'EString' && attr.name !== 'description' && attr.many">
                      <a-input
                          v-for="val in attr.value"
                          :value="val"
                          type="text"
                          @change="(e) => eddChanged(attr, e)"
                          @blur="updateAttribute(attr.name, attr.value, attr, obj_properties.object)"
                      />
                    </template>
                    <a-textarea
                        v-else-if="attr.type === 'EString' && attr.name === 'description'"
                        v-model:value="attr.value"
                        :auto-size="{ minRows: 2, maxRows: 5 }"
                        @change="(e) => eddChanged(attr, e)"
                        @blur="updateAttribute(attr.name, attr.value, attr, obj_properties.object)"
                    />
                    <a-select
                        v-else-if="attr.type === 'EEnum' || attr.type === 'EBoolean'"
                        v-model:value="attr.value" style="width: 100%"
                        :options="dropdownOptions(attr.options)"
                        @change="(e) => { eddChanged(attr, e); updateAttribute(attr.name, attr.value, attr, obj_properties.object) }"
                    />
                    <a-date-picker
                        v-else-if="attr.type === 'EDate'"
                        format="YYYY-MM-DD HH:mm:ss"
                        style="width: 100%"
                        :default-value="get_default_date(attr.value)"
                        :show-time="{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }"
                        @change="(date, dateString) => { eddChanged(attr, date); updateDateAttribute(date, dateString, attr.name); }"
                    />
                    <template v-else>
                      <span style="color: red">!</span>
                      <a-input
                          v-model:value="attr.value"
                          type="text"
                          @changed="eddChanged(attr, e)"
                          @blur="updateAttribute(attr.name, attr.value, attr, obj_properties.object)"
                      />
                    </template>

                  </a-col>
                  <a-col v-if="!isAttribute(attr)"
                         :span="23">
                    <a-row :gutter="[0, 16]" type="flex" align="middle">
                      <!--                            <ReferenceViewer-->
                      <!--                                :parent-object-i-d="currentObjectIDs[0]"-->
                      <!--                                :reference="attr"-->
                      <!--                                @update="updateRef($event, attr)"-->
                      <!--                            />-->
                      <span>! {{ attr.name }}</span>
                    </a-row>
                  </a-col>
                  <a-col :span="1">
                    <template v-if="attr.doc">
                      <a-tooltip :title="attr.doc">
                        <span style="width: 22px; display:inline-block">&nbsp; <info-circle-outlined style="color: rgba(0, 0,255, 0.45)"/></span>
                      </a-tooltip>
                    </template>
                  </a-col>
                </a-row>
                <!-- references -->
                <template v-for="ref in obj_properties.references" :key="ref.name">
                  <template v-if="!ref.containment">
                    <a-row v-if="!ref.containment" :gutter="[4, 16]" type="flex" align="middle">

                      <a-col :span="8">
                        <span :title="ref.doc">{{ camelCase(ref.name) }}</span>
                      </a-col>
                      <a-col :span="15">
                        <a-input-group compact>
                          <template v-if="ref.many">
                            <a-select multiple :value="referenceValuesToOptions(ref.value)"
                                      mode="tags"
                                      @change="(e) => eddChanged(attr, e)"
                                      style="width: calc(100% - 89px)"/>
                          </template>
                          <template v-else>
                            <a-input v-model:value="ref.value.repr" :bordered="true" readonly :disabled="ref.eopposite"
                                     style="width: calc(100% - 89px)"/>
                          </template>
                          <!--<span class="ant-input">&nbsp;{{ ref.value.repr}}</span>-->
                          <a-button title="Delete reference" :disabled="ref.eopposite"><delete-outlined/></a-button>
                           <a-button title="Select reference" :disabled="ref.eopposite" @click="selectReference(ref)">...</a-button>
                        </a-input-group>
                      </a-col>
                      <a-col :span="1">
                        <template v-if="ref.doc">
                          <a-tooltip :title="ref.doc">
                            <span style="width: 18px; display:inline-block">&nbsp;<info-circle-outlined style="color: rgba(200, 0, 255, 0.45)"/></span>
                          </a-tooltip>
                        </template>
                      </a-col>
                    </a-row>
                  </template>
                </template>
              </div>
            </a-col>
          </a-row>

          <a-row v-if="obj_properties.object.type === 'Image'">
            <a-col :span="24">
              <div style="margin-bottom: 10px;">
                <ImageUpload
                  :object-properties="obj_properties"
                  @update:image="handleImageUpload"
                />
              </div>
            </a-col>
          </a-row>

        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>

  <a-modal :visible="choice_modal_visible" title="Select the ESDL object you want to add" @ok="handleChoiceModalOk" @cancel="handleChoiceModalCancel">
    <a-select
      v-model:value="choice_modal_selected_option"
      show-search
      placeholder="Select an option"
      style="width: 400px"
      :options="choice_modal_options"
      :filter-option="choiceModalFilterOption"
    />
  </a-modal>
  <a-modal :visible="select_ref_modal_visible" title="Select a reference" width="700px" @ok="handleSelectRefModalOk" @cancel="handleSelectRefModalCancel">
    <span>
      Please select a reference from the drop down for the <span style="font-weight: bold">{{ ucFirst(select_ref ? select_ref.name : '')}}</span> reference
    </span>
    <a-select
      v-model:value="select_ref_modal_references"
      show-search
      placeholder="Select an reference"
      style="width: 600px"
      :options="select_ref_modal_options"
      max-tag-count="responsive"
      :mode="select_ref?.many ? 'multiple' : ''"
      :filter-option="choiceModalFilterOption"
    >
      <template #option="{ value: val, label, container_repr, etype }">
         {{ label }} <span class="label_suffix">[of {{container_repr }}]</span>
        <span class="label_type"> [{{etype}}]</span>
      </template>
    </a-select>
  </a-modal>
  <a-modal :visible="commit_message_modal_visible" title="Commit Message" @ok="handleCommitMessageModalOk" @cancel="handleCommitMessageModalCancel">
    <a-textarea
      v-model:value="commit_message"
      placeholder="Enter commit message"
      :rows="1"
    />
  </a-modal>
</template>

<script setup>
import {defineProps, onMounted, ref, unref, watch} from 'vue';
import {useKeycloak} from "@/keycloak/authentication";
import {API_HOST} from "@/envconfig";
import FancyNumberEdit from "@/components/FancyNumberEdit.vue";
import TagEditor from "@/components/TagEditor.vue";
import dayjs from "dayjs";
import {InfoCircleOutlined, DeleteOutlined, SaveOutlined, UploadOutlined} from '@ant-design/icons-vue';
import ImageUpload from "@/components/ImageUpload.vue";


const {getHeaders} = useKeycloak();

const props = defineProps({
  id: String,
  writable: Boolean,
  new_item: Boolean,
});

const ContentType = Object.freeze({
  EDIT_PROPERTIES: 0,
  SELECT_EOBJECT: 1,
});

const expandedKeys = ref([]);
const selectedKeys = ref([]);
const treeData = ref([]);
const is_tree_loading = ref(false);
const is_prop_loading = ref(true);
const content_type = ref(ContentType.EDIT_PROPERTIES);

const choice_modal_visible = ref(false);
const choice_modal_options = ref([]);
const choice_modal_selected_option = ref("");
const selected_context_menu_option = ref("");         // selected attribute from the context menu
const saved_context_menu_element = ref({});           // reference to the element on which the context menu was opened
const save_in_progress = ref(false);
const save_button_enabled = ref(false);
const select_ref_modal_visible = ref(false);
const select_ref_modal_references = ref([]);
const select_ref_modal_options = ref([]);
const select_ref = ref(null);
const commit_message_modal_visible = ref(false);
const commit_message = ref("");

const breadcrumbs = ref(['EnergyDataDescription']);
const obj_properties = ref({});


watch(() => props.id, watchContainmentTree, {immediate: true})

async function watchContainmentTree(id) {
  await fetchContainmentTree(id, "/");
}

async function fetchContainmentTree(id, selectedKey=null) {
  // init EDD in backend
  // load main EDD similar to code in mapeditor (getAttributes)
  // console.log("Fetching EDD " + id);
  is_tree_loading.value = true;
  //save_button_enabled.value = false;
  const headers = getHeaders();
  const path = `${API_HOST}/api/admin/raw_edd?id=` + encodeURIComponent(id);
  breadcrumbs.value.splice(1, breadcrumbs.value.length);
  if (!selectedKey) {
    selectedKeys.value.length = 0; // reset tree selection
  } else {
    selectedKeys.value = [selectedKey];
  }
  const response = await fetch(path, {
    method: 'GET',
    headers: headers
  });
  // console.log("Secured API response", response);

  const body = await response.json();
  if (response.ok) {
    // const msg = "Get raw EDD: "
    // console.log(msg, body);
    //alert(msg);
    treeData.value = [body];
    is_tree_loading.value = false;
    await getEDDDetails();
  } else {
    const msg = "Error " + response.status + " " + response.statusText + ": " + body;
    is_tree_loading.value = false;
    console.error(msg);
    alert(msg);
  }
}

async function selectTreeItem(keys, e) {
  // console.log("Selected keys", keys, e);

  let node = e.node.parent;
  breadcrumbs.value.length = 0; // reset items
  breadcrumbs.value.push(e.node.etype);
  while (node) {
    breadcrumbs.value.push(node.node.etype);
    if (node.parent) {
      node = node.parent;
    } else {
      break;
    }
  }
  breadcrumbs.value.reverse();
  // console.log('breadcrumbs', breadcrumbs.value);
   if (keys.length === 0 || keys[0] === undefined) {
    return;
  }
  await getEDDDetails();
}

async function getEDDDetails() {
  // selectedKeys = unref(selectedKeys);
  // console.log("getEDDDetails - selectedKeys", selectedKeys.value);
  if (selectedKeys.value.length === 0) {
    selectedKeys.value = ['/']; // default show root object
  }

  // get object properties (attributes & references)
  is_prop_loading.value = true
  const headers = getHeaders();
  const path = `${API_HOST}/api/admin/edd_details?id=`
      + encodeURIComponent(props.id) + '&fragment='
      + encodeURIComponent(selectedKeys.value[0]);

  const response = await fetch(path, {
    method: 'GET',
    headers: headers
  });
  // console.log("Secured API response", response);

  const body = await response.json();
  if (response.ok) {
    //const msg = "Get details EDD: "
    //console.log(msg, body);
    obj_properties.value = body;
    is_prop_loading.value = false;
  } else {
    const msg = "Error " + response.status + " " + response.statusText + ": " + body;
    obj_properties.value = {};
    is_prop_loading.value = false;
    console.error(msg);
    alert(msg);
  }
}

function choiceModalFilterOption(input, option) {
  return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
}

function handleChoiceModalOk() {
  choice_modal_visible.value = false;
  addContainment(choice_modal_selected_option.value, selected_context_menu_option.value);
}

function handleChoiceModalCancel() {
  choice_modal_visible.value = false;
}


async function addContainment(containment_type, menuKey) {
  const headers = getHeaders();
  headers["Content-Type"] = "application/json";
  const path = `${API_HOST}/api/admin/edd_add_containment`;

  // console.log("Selected type", containment_type);
  let data = {
    id: props.id,
    fragment: saved_context_menu_element.value.key,   // selectedKeys.value[0],
    feature: menuKey,
    type: containment_type
  }
  // console.log("Add containment", data);

  if (!(saved_context_menu_element.value.key in expandedKeys.value)) {
    expandedKeys.value.push(saved_context_menu_element.value.key);
  }

  const response = await fetch(path, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
    //credentials: "include"  // todo: make this work in dev environment
  });
  save_button_enabled.value = true;
  // console.log('save button', unref(save_button_enabled));
  const body = await response.json();
  if (response.ok) {
    // console.log("Added containment relation:", body);

    //alert(msg);
    await fetchContainmentTree(props.id, body.fragment);
  } else {
    const msg = "Error " + response.status + " " + response.statusText + ": " + body;
    console.error(response.status, response.statusText, msg, body);
    alert(msg);
  }
}

async function onContextMenuClick(dataRef, menuKey, menuItem) {
  // console.log(`treeKey:`, dataRef, 'menuKey:', menuKey, menuItem);
  saved_context_menu_element.value = dataRef;

  if (menuKey === "delete") {
    await deleteObject(dataRef);
    await fetchContainmentTree(props.id);
    return;
  }
  // if something else than "delete" was selected in the context menu, we need to add a new containment relation

  // find containment reference that is selected based on its name
  let containment_ref = null;
  let containment_type = null;
  for (let i in dataRef.containment_refs) {
    if (dataRef.containment_refs[i].name === menuKey) {
      containment_ref = dataRef.containment_refs[i];
      break;
    }
  }
  // console.log("Selected containment ref", containment_ref)
  if (!containment_ref) { return; }
  if (containment_ref.types.length <= 1) {
    containment_type = containment_ref.types[0];
    await addContainment(containment_type, menuKey);
  } else {
    // many subtypes, show dialog
    choice_modal_options.value = []
    // check if first element in the list is a dictionary, then the returned data is using option grouping
    if (containment_ref.types[0].constructor == Object) {
      for (let i = 0; i < containment_ref.types.length; i++) {
        let option_group = {
          label: containment_ref.types[i].title,
          options: []
        };
        for (let j=0; j < containment_ref.types[i].options.length; j++) {
          option_group['options'].push({value: containment_ref.types[i].options[j], label: containment_ref.types[i].options[j]});
        }
        choice_modal_options.value.push(option_group);
      }
    } else {
      for (let i = 0; i < containment_ref.types.length; i++) {
        choice_modal_options.value.push({value: containment_ref.types[i], label: containment_ref.types[i]});
      }
    }
    choice_modal_selected_option.value = "";      // Clear previous selected value

    // the rest is handled by the event handler connected to the OK button in the dialogue
    // for now: store menuKey to be used in the event handler
    selected_context_menu_option.value = menuKey;
    choice_modal_visible.value = true;
  }
}

function handleImageUpload(val) {
  save_button_enabled.value = true;
  updateAttribute('base64ImageData', val.base64ImageData);
  updateAttribute('contentType', val.contentType);
}


function ucFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function camelCase(str) {
  if (str.match(/^[^a-z]+$/g)) {
    return str;
  } // if no lowercase characters found, just use the word as given, e.g. COP
  return str.match(/^[a-z]+|[A-Z][a-z]*/g).map(function (x) {
    return x[0].toUpperCase() + x.substring(1).toLowerCase();
  }).join(' ');
}

function asNumber(str) {
  return Number(str)
}

function dropdownOptions(attrOpts) {
  return attrOpts.map((opt) => {
    return {
      label: opt,
      value: opt,
    };
  });
}

function eddChanged(attr, e) {
  // called when an input changes
  // console.log("Attr change", attr, e);
  save_button_enabled.value = true;
}

function mutateMenuItemInTree(treeElement, key, newValue) {
  if (treeElement.key === key) {
    treeElement.title = newValue;
    return;
  }
  if (treeElement.children) {
    treeElement.children.forEach((child) => mutateMenuItemInTree(child, key, newValue));
  }
}

async function updateAttribute(name, new_value, attr, eobject) {
  // in some cases attr and eobject are present, but not in all...
  // console.log("setting param " + name + " to value " + new_value, selectedKeys, selectedKeys.value[0]);
  if (selectedKeys.value.length === 0 || selectedKeys.value[0] === undefined) {
    return;
  }

  //console.log("mutateattr", attr, eobject, selectedKeys.value[0], new_value);
  //if (['title', 'name'].indexOf(name) > -1) {
  if (attr && attr.type === 'EString' && ['title', 'name'].indexOf(attr.name) > -1) {
    // console.log(name);
    mutateMenuItemInTree(treeData.value[0], selectedKeys.value[0], new_value);
  }

  const headers = getHeaders();
  headers["Content-Type"] = "application/json";
  const path = `${API_HOST}/api/admin/edd_update_attribute`;

  let data = {
    id: props.id,
    fragment: selectedKeys.value[0],
    name: name,
    value: new_value
  }
  // console.log("Data", data);

  const response = await fetch(path, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
    //credentials: "include"  // todo: make this work in dev environment
  });
  // console.log("Secured API response", response);

  const body = await response.json();
  if (response.ok) {
    //console.log(eobject.type)
    if (eobject && eobject.type === 'QuantityAndUnitType' && ['physicalQuantity', 'unit', 'multiplier', 'perMultiplier', 'perScope', 'perTimeUnit', 'perUnit'].indexOf(name) > -1) {
      const headers = getHeaders();
      headers["Content-Type"] = "application/json";
      const path = `${API_HOST}/api/admin/edd_update_qau_description`;

      let data = {
        id: props.id,
        fragment: selectedKeys.value[0],
      }

      const response = await fetch(path, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
      });

      const body = await response.json();
      if (response.ok) {
        // result contains QaU description
        for (let i=0; i < obj_properties.value.attributes.length; i++) {
          if (obj_properties.value.attributes[i].name === 'description') {
            obj_properties.value.attributes[i].value = body.qau_description;
            mutateMenuItemInTree(treeData.value[0], selectedKeys.value[0], body.qau_description);
          }
        }
      } else {
        const msg = "Error " + response.status + " " + response.statusText + ": " + body;
        console.error(msg);
        alert(msg);
      }
    }
  } else {
    const msg = "Error " + response.status + " " + response.statusText + ": " + body;
    console.error(msg);
    alert(msg);
  }
}

async function deleteObject(dataref) {
  const headers = getHeaders();
  headers["Content-Type"] = "application/json";
  const path = `${API_HOST}/api/admin/edd_delete_object`;

  let data = {
    id: props.id,
    fragment: saved_context_menu_element.value.key,
    //selectedKeys.valueg[0] only works if the item is selected, so use saved_context_menu_element
  }
  // console.log("Data", data);

  const response = await fetch(path, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
  });
  save_button_enabled.value = true;
  const body = await response.json();
  if (!(response.ok)) {
    const msg = "Error " + response.status + " " + response.statusText + ": " + body;
    console.error(msg, body);
    alert(msg);
  }
}


function updateDateAttribute(date, dateString, name) {
  let new_value;
  if (date) {
    new_value = date.format('YYYY-MM-DDTHH:mm:ss.SSSSSSZZ');
  } else {
    new_value = '';
  }
  updateAttribute(name, new_value);
}

function get_default_date(value) {
  // console.log("Getting default date", value)
  if (value)
    return dayjs(value, 'YYYY-MM-DDTHH:mm:ss.SSSSSSZZ')
  else
    return null;
}

function isAttribute(feature) {
  // in the combined features list (attributes and references) one can check if it is an attibute or not.
  return !('containment' in feature);
}


async function saveEDD() {
  save_in_progress.value = true;
  save_button_enabled.value = false;
  const headers = getHeaders();
  headers["Content-Type"] = "application/json";
  const path = `${API_HOST}/api/admin/edd_save`;

  let data = {
    id: props.id,
    commitMessage: commit_message.value
  }
  // console.log("Save Data", data);

  const response = await fetch(path, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
  });

  const body = await response.json();
  if (!(response.ok)) {
    const msg = "Error " + response.status + " " + response.statusText + ": " + body;
    console.error(msg, body);
    alert(msg);
  }
  save_in_progress.value = false;
  //save_button_enabled.value = true;
}

async function selectReference(ref) {
  // console.log("Select reference", ref);
  select_ref.value = ref;
  // find references in EDD via backend
  const headers = getHeaders();
  headers["Content-Type"] = "application/json";
  const path = `${API_HOST}/api/admin/find_refs`;

  // TODO: add commit message
  let data = {
    id: props.id,
    type: ref.type,
    types: ref.types,
  }
  // console.log("Find references", data);

  const response = await fetch(path, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
  });

  const body = await response.json();
  if (response.ok) {
    // console.log("Find refs response:", body);
    select_ref_modal_options.value = []
    let selection = []
    for (let i = 0; i < body.xreferences.length; i++) {
      select_ref_modal_options.value.push(
          {
            key: body.xreferences[i].fragment,
            value: body.xreferences[i].fragment,
            label: body.xreferences[i].repr,
            container_repr: body.xreferences[i].container.repr,
            etype: body.xreferences[i].type
          });
      // show current selection in input field
      if (Array.isArray(ref.value)) {
        for (let j = 0; j < ref.value.length; j++) {
          if (ref.value[j].fragment === body.xreferences[i].fragment) {
            selection.push(body.xreferences[i].fragment);
          }
        }
      } else if(ref.value.fragment === body.xreferences[i].fragment) {
        selection = ref.value.fragment;
      }
      // console.log('Selection', selection, ref.value)
    }
    select_ref_modal_references.value = selection;      // Clear previous selected value
    select_ref_modal_visible.value = true;
  } else {
    const msg = "Error " + response.status + " " + response.statusText + ": " + body;
    console.error(msg, body);
    alert(msg);
  }
  // show dialog with references to choose from
  // add references in backend
  // update reference in reference overview
}

async function handleSelectRefModalOk() {
  select_ref_modal_visible.value = false;
  let ref = select_ref.value;
  // console.log('Selected ref(s): ',select_ref_modal_references.value, 'for ref:', ref);
  // update refs of EDD in backend
   const headers = getHeaders();
  headers["Content-Type"] = "application/json";
  const path = `${API_HOST}/api/admin/update_refs`;
  const values = Array.isArray(select_ref_modal_references.value) ? select_ref_modal_references.value : [select_ref_modal_references.value];
  let data = {
    id: props.id,
    fragment: selectedKeys.value[0],
    feature: ref.name,
    values: values,
  }
  // console.log("Find references", data);

  const response = await fetch(path, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
  });

  const body = await response.json();
  if (response.ok) {
    // console.log("update selected keys:", body);
    await getEDDDetails(selectedKeys);
  } else {
    const msg = "Error " + response.status + " " + response.statusText + ": " + body;
    console.error(msg, body);
    alert(msg);
  }


  select_ref.value = null;
}

async function handleSelectRefModalCancel() {
  select_ref_modal_visible.value = false;
  select_ref.value = null;
}

function referenceValuesToOptions(value) {
  let options = [];
  for (let i = 0; i < value.length; i++) {
    //options.push({label: value[i].repr, key: value[i].fragment, eType: value[i].type});
    options.push(value[i].repr);
  }
  // console.log(options);
  return options;
}

function handleCommitMessageModalOk() {
  commit_message_modal_visible.value = false;
  saveEDD();
}

function handleCommitMessageModalCancel() {
  commit_message_modal_visible.value = false;
}

function showCommitModal() {
  commit_message_modal_visible.value = true;
}


</script>

<style scoped>

.feature_prefix {
  font-family: monospace;
  font-size: 80%;
  color: darkred;
}
.label_suffix {
  font-style: italic;
  color: cadetblue;
  font-size: 85%;
}

.label_type {
  color: #42b983;
  font-size: 85%;
}
</style>